import Vue from 'vue';
import Vuex from 'vuex';
import {
  getSite,
  setSite,
  setNav,
  getNav,
  getSiteOne,
  setSiteOne,
  getModel,
  setModel,
} from '@/assets/api/token.js';
import { fetchSite, fetchCmsColumn, fetchModel } from '@/assets/api';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    siteList: JSON.parse(getSite()) || [], //站点列表
    siteValue: getSiteOne() || null, //选中的站点值
    navTree: JSON.parse(getNav()) || [], //栏目树
    modelList: JSON.parse(getModel()) || [], //模型列表
  },
  getters: {},

  mutations: {
    setSiteList(state, value) {
      state.siteList = value;
    },
    setSiteValue(state, value) {
      state.siteValue = value;
    },
    SET_TREE(state, value) {
      state.navTree = value;
    },
    SET_MODEL(state, value) {
      state.modelList = value;
    },
  },
  actions: {
    // 获取站点
    getSite({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        fetchSite({ current: 1, size: 999 }).then(async (res) => {
          if (res.code == 200) {
            // 获取当前年
            // const year = new Date().getFullYear();
            // let siteId = '';
            // res.data.records.map((r) => {
            //   if (r.keywords.includes(year) && r.keywords.includes('cn')) {
            //     siteId = r.id;
            //   }
            // });
            // commit('setSiteList', res.data.records);
            // commit('setSiteValue', getSiteOne() || siteId);
            // setSiteOne(getSiteOne() || siteId);
            // setSite(JSON.stringify(res.data.records));
            const list = res.data.records.filter(
              (r) => !r.keywords.includes('en')
            );
            commit('setSiteList', list);
            commit('setSiteValue', getSiteOne() || list[0].id);
            setSiteOne(getSiteOne() || list[0].id);
            setSite(JSON.stringify(list));

            dispatch('getCloumn').then((ress) => {
              resolve(ress);
            }); //获取栏目
            dispatch('getModel'); //获取模型
          }
        });
      });
    },
    getCloumn({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        fetchCmsColumn().then((res) => {
          if (res.code == 200) {
            const listTree = res.data;
            setNav(JSON.stringify(listTree));
            commit('SET_TREE', listTree);
            resolve(res.data);
          }
        });
      });
    },
    getModel({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        fetchModel().then((res) => {
          if (res.code == 200) {
            const modelList = res.data;
            setModel(JSON.stringify(modelList));
            commit('SET_MODEL', modelList);
            resolve(res.data);
          }
        });
      });
    },
  },
});
